import React from 'react'
import { 
    CellsTitle, Cells, TextArea, CellBody, Form, FormCell, Button,
    Toast, Dialog, Toptips, Select, CellFooter, Switch, Radio
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { browserHistory } from 'react-router'
import Header from '../../components/liveroomLecturer/Header'
import '../../css/page/ChannelLectureEditPage.css'


class LectureEditModePage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            mode: 'picture',
            originMode: 'picture',
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        this.fetchData()
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get(`/api/lecture/${this.props.params.id}/edit_info`)
            .then(res => {
                this.setState({ 
                    mode: res.data.data.lecture.image_mode, 
                    originMode: res.data.data.lecture.image_mode,
                    isPending: false,
                })
            })
    }
    showAlert (text) {
        this.setState({
            alertDialog: { isShow: true, text }
        })
    }
    onClickAlertOk () {
        browserHistory.go(-1)
    }
    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
    }
    onSubmit (e) {
        this.setState({ isPending: true })
        axios.post(`/api/lecture/${this.props.params.id}/edit`, qs.stringify({
            image_mode: this.state.mode,
        }))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.showAlert('修改成功')
            })
    }
    onChangeRadio (e, value) {
        this.setState({ mode: value })
    }
    render() {
        return (
            <div className='page'>
                <div className="wk-inner-page channel-lecture-edit-page">
                    <div>
                        <Header title='使用课件' />
                        <Form className='margin-bottom' radio>
                            <FormCell radio>
                                <CellBody>无</CellBody>
                                <CellFooter>
                                    <Radio 
                                        name="mode" 
                                        checked={this.state.mode === 'picture'} 
                                        onChange={e => this.onChangeRadio(e, 'picture')} 
                                    />
                                </CellFooter>
                            </FormCell>
                            <FormCell radio>
                                <CellBody>PPT</CellBody>
                                <CellFooter>
                                    <Radio 
                                        name="mode" 
                                        checked={this.state.mode === 'ppt'} 
                                        onChange={e => this.onChangeRadio(e, 'ppt')} 
                                    />
                                </CellFooter>
                            </FormCell>
                            {
                                this.state.originMode === 'audio' && (
                                    <FormCell radio>
                                        <CellBody>音频</CellBody>
                                        <CellFooter>
                                            <Radio 
                                                name="mode" 
                                                checked={this.state.mode === 'audio'} 
                                                onChange={e => this.onChangeRadio(e, 'audio')} 
                                            />
                                        </CellFooter>
                                    </FormCell>
                                )
                            }
                            <FormCell radio>
                                <CellBody>视频</CellBody>
                                <CellFooter>
                                    <Radio 
                                        name="mode" 
                                        checked={this.state.mode === 'video'} 
                                        onChange={e => this.onChangeRadio(e, 'video')} 
                                    />
                                </CellFooter>
                            </FormCell>
                        </Form>
                        <p className="intro sm">直播时，会在课堂顶部显示课件。</p>
                        <p className="intro sm">{this.state.originMode === 'audio' ? '音频和' : ''}视频课件必须在讲师管理后台上传。</p>
                        <p className="intro sm margin-bottom">PPT课件在讲师管理后台可以上传ppt，pptx，pdf等文件，在手机上只能上传图片。</p>
                        <div className="wk-btn-90 padding-top-10">
                            <Button onClick={e => this.onSubmit()}>保存</Button>
                        </div>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.onClickAlertOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}


export default LectureEditModePage


// WEBPACK FOOTER //
// ./src/pages/LectureEdit/LectureEditModePage.js